// cart-drawer.js
document.addEventListener('DOMContentLoaded', () => {
  const FREE_SHIPPING_THRESHOLD = 10000; // in cents
  const JULY4_DISCOUNT_PATTERN = /4TH[\s_-]*OF[\s_-]*JULY(?:[\s_-]*[A-Z0-9]+)?|4TH[\s_-]*JULY(?:[\s_-]*[A-Z0-9]+)?/i;

  // Inject CSS for custom dropdown
  ;(function injectStyles() {
    const css = `
      /* Custom quantity dropdown */
      .custom-qty-dropdown {
        position: relative;
        display: inline-block;
        width: 4ch; /* enough for up to two digits + padding */
      }
      .custom-qty-toggle {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #000;
        border-radius: 2px;
        background: rgb(255, 255, 255);
        padding: 0.25em 0.5em;
        font-size: 1em;
        color: #000;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
      }
      .custom-qty-toggle:focus {
        outline: none;
      }
      .custom-qty-carrot {
        width: 0.6em;
        height: auto;
        pointer-events: none;
      }
      .custom-qty-options {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        margin:0;
        padding: 0;
        list-style: none;
        background: rgb(244, 242, 235);
        border: 1px solid #000;
        
        border-radius: 2px;
        max-height: 17em;
        overflow-y: auto;
        box-sizing: border-box;
        z-index: 10;
        display: none;
      }
      .custom-qty-options.open {
        display: block;
      }
      .custom-qty-option {
        padding-left: 0.5em;
        cursor: pointer;
        font-size:.8em;
      }
      .custom-qty-option:hover,
      .custom-qty-option[aria-selected="true"] {
        background: #f4f2eb;
      }
      /* Keep trash and dropdown centered */
      .cart-item__actions {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      /* Hide old subtotal if present */
      .cart-item-subtotal {
        display: none;
      }
    `;
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  })();

  const body          = document.body;
  const drawer        = document.querySelector('.cart-drawer');
  const closeBtn      = drawer.querySelector('.cart-drawer__close-btn');
  const backdrop      = drawer.querySelector('.cart-drawer__backdrop');
  const drawerContent = document.getElementById('CartDrawerItems');
  const footer        = drawer.querySelector('.cart-drawer__footer');
  const openBtn       = document.querySelector('[data-open-drawer]');

  // —————————————————————
  // Helpers
  // —————————————————————
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2); // always 2 decimals to start
    // If it's exactly .00, drop the decimals entirely (e.g., 2000 -> $20)
    if (dollars.endsWith('.00')) return `$${dollars.slice(0, -3)}`;
    // Otherwise keep both decimals (e.g., 79.20 stays 79.20; 19.80 stays 19.80)
    return `$${dollars}`;
  }

  function openDrawer() {
    body.classList.add('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  // —————————————————————
  // Free-shipping progress
  // —————————————————————
  function updateFreeShippingProgress(cart) {
    const msgEl  = drawer.querySelector('.free-shipping-message');
    const fillEl = drawer.querySelector('.free-shipping-fill');
    const total  = cart.total_price;

    if (total >= FREE_SHIPPING_THRESHOLD) {
      msgEl.textContent = 'Congratulations! You’ve earned free shipping.';
      fillEl.style.width  = '100%';
    } else {
      const left    = FREE_SHIPPING_THRESHOLD - total;
      const percent = (total / FREE_SHIPPING_THRESHOLD) * 100;
      msgEl.textContent = `Add ${formatMoney(left)} more for free shipping.`;
      fillEl.style.width = `${percent}%`;
    }
  }

  // —————————————————————
  // Cart count bubble
  // —————————————————————
  function updateCartCount(cart) {
    const bubble = drawer.querySelector('.cart-count-bubble');
    if (!bubble) return;

    const visible = bubble.querySelector('span[aria-hidden]');
    if (visible) {
      if (cart.item_count === 0) {
        bubble.style.display = 'none';
      } else {
        bubble.style.display = '';
        if (cart.item_count < 100) {
          visible.textContent = ` (${cart.item_count})`;
          visible.style.display = '';
        } else {
          visible.style.display = 'none';
        }
      }
    }

    const sr = bubble.querySelector('.visually-hidden');
    if (sr) {
      sr.textContent = `${cart.item_count} item${cart.item_count === 1 ? '' : 's'} in cart`;
    }
  }

  // —————————————————————
  // Build one item’s HTML (with custom dropdown)
  // —————————————————————
  function buildItemHTML(item, compareMap, inventoryMap, tagsMap, isHURRY25Active = false, isFourthOfJulyActive = false) {
  // ───────────────── helpers ─────────────────
  const esc = (s) =>
    String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const discountIconSvg = `
    <svg aria-hidden="true" viewBox="0 0 12 12" width="12" height="12">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
        fill="currentColor"></path>
    </svg>`;

  // ───────────────── data ─────────────────
  const key       = item.key;
  const url       = item.url;
  const img       = item.image;
  const title     = item.product_title;
  const qty       = item.quantity;
  const unitPrice = typeof item.final_price === 'number' ? item.final_price : item.price; // cents
  const unitOriginalPrice = typeof item.original_price === 'number' ? item.original_price : item.price;
  const cmpUnit   = compareMap[item.variant_id] || 0;   // cents (compare_at or fallback)

  // Prefer API-provided line totals
  const lineOriginal = typeof item.original_line_price === 'number'
    ? item.original_line_price
    : unitOriginalPrice * qty;

  const lineFinal = typeof item.final_line_price === 'number'
    ? item.final_line_price
    : (typeof item.line_price === 'number' ? item.line_price : unitPrice * qty);

  const hasLineDiscount  = lineFinal < lineOriginal;
  const hasCompareAtSale = !hasLineDiscount && cmpUnit > unitPrice;

  // Options line e.g. "Black | L"
  const optsLine = (Array.isArray(item.options_with_values) ? item.options_with_values : [])
    .map(o => o.value)
    .join(' | ');

  // Product tags for Final Sale message

const productTagsStr = (tagsMap?.[item.variant_id] || '').toString().toLowerCase();
const tagList = productTagsStr.split(',').map(t => t.trim()).filter(Boolean);
const isExcludedFromPromotion = tagList.includes('excluded from promotion');
  const discounts = Array.isArray(item.discounts) ? item.discounts : [];
  const hasJuly4LineDiscount = discounts.some((d) => JULY4_DISCOUNT_PATTERN.test(String(d?.title || '')));

// Determine if discounted (line discount OR compare-at sale)
const isDiscounted = hasLineDiscount || hasCompareAtSale;

// Final sale if tagged OR discounted OR HURRY25 is active OR 4th of July codes applied
  const isFinalSale =
    tagList.includes('last chance') ||
    tagList.includes('final sale') ||
    isHURRY25Active ||
    isFourthOfJulyActive ||
    hasJuly4LineDiscount;

  // ───────────────── price markup ─────────────────
  let priceHtml = '';
  if (hasLineDiscount) {
    // Original (struck) vs discounted line totals
    if (isFinalSale) {
        priceHtml = `
            <div class="cart-item__discounted-prices">
                <s class="cart-item__old-price">${formatMoney(lineOriginal)}</s>
                <strong class="cart-item__final-price red">${formatMoney(lineFinal)}</strong>
            </div>`;
    }else{
        priceHtml = `
            <div class="cart-item__discounted-prices">
                <s class="cart-item__old-price">${formatMoney(lineOriginal)}</s>
                <strong class="cart-item__final-price">${formatMoney(lineFinal)}</strong>
            </div>`;
    }
  
  } else if (hasCompareAtSale) {
    const oldLine = cmpUnit * qty;
    const newLine = lineFinal;
    priceHtml = `
      <div class="cart-item__discounted-prices">
        <s class="cart-item__old-price">${formatMoney(oldLine)}</s>
        <strong class="cart-item__final-price red">${formatMoney(newLine)}</strong>
      </div>`;
  } else {
    priceHtml = `<div class="cart-item__price">${formatMoney(lineFinal)}</div>`;
  }

  // ───────────────── discounts list ─────────────────
  const discountsHtml = discounts.length
    ? `<ul class="discounts list-unstyled" role="list" aria-label="Discounts">
         ${discounts.map(d => `
           <li class="discounts__discount">
             ${discountIconSvg} ${esc(d.title)}
           </li>`).join('')}
       </ul>`
    : '';

  // ───────────────── final sale message ─────────────────
  const finalSaleHtml = isFinalSale
    ? `<p class="discount-mssg red">
         Final Sale
       </p>`
    : '';

  const excludedPromotionHtml = isExcludedFromPromotion
    ? `<p class="discount-mssg excluded">
         EXCLUDED FROM PROMOTION
       </p>`
    : '';

  // ───────────────── quantity dropdown (with 0=Remove) ─────────────────
  const available     = inventoryMap[item.variant_id] != null ? inventoryMap[item.variant_id] : 0;
  const maxSelectable = available > 10 ? 10 : available; // cap at 10
  const displayMax    = Math.max(maxSelectable, qty);    // always include current qty

  let optionsHtml = `
    <li class="custom-qty-option" role="option" data-value="0" aria-selected="false">
      0
    </li>`;
  for (let i = 1; i <= displayMax; i++) {
    optionsHtml += `
      <li class="custom-qty-option"
          role="option"
          data-value="${i}"
          aria-selected="${i === qty}">
        ${i}
      </li>`;
  }

  const dropdownHtml = `
    <div class="custom-qty-dropdown" data-line-item-key="${esc(key)}">
      <button type="button"
              class="custom-qty-toggle"
              aria-haspopup="listbox"
              aria-expanded="false">
        <span class="custom-qty-label">${qty}</span>
        <svg class="custom-qty-carrot" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
          <path d="M1 1l4 4 4-4" stroke="#000" stroke-width="1" fill="none"/>
        </svg>
      </button>
      <ul class="custom-qty-options" role="listbox">
        ${optionsHtml}
      </ul>
    </div>`;

  // ───────────────── markup ─────────────────
  return `
    <div class="cart-item" data-key="${esc(key)}"
         style="display:flex;gap:1.5rem;align-items:flex-start;">
      <div class="cart-item__media" style="max-width:120px;">
        <a href="${esc(url)}" class="product_link">
          <img src="${esc(img)}"
               width="120" height="200"
               alt="${esc(title)}"
               style="width:100%;height:auto;">
        </a>
      </div>

      <div class="cart-item__details" style="flex:1;">
        <a href="${esc(url)}" class="product_link">
          <h3 class="h5" style="margin:0;">${esc(title)}</h3>
        </a>
        <p class="product-option" style="margin:0;">
          ${esc(optsLine)}
        </p>
        ${priceHtml}
        ${excludedPromotionHtml}
        ${discountsHtml}
        ${finalSaleHtml}
      </div>

      <div class="cart-item__actions">
        ${dropdownHtml}
      </div>
    </div>`;
}



  // —————————————————————
  // Check if HURRY25 code is active
  // —————————————————————
  function isHURRY25Active(cart) {
    if (!Array.isArray(cart.discount_codes)) return false;
    return cart.discount_codes.some(dc => 
      dc.code && dc.code.toUpperCase() === 'HURRY25'
    );
  }

  function matchesJuly4Discount(value) {
    return JULY4_DISCOUNT_PATTERN.test(String(value || ''));
  }

  // Check if any 4th of July discount code is active
  // —————————————————————
  function isFourthOfJulyActive(cart) {
    const codeHits = Array.isArray(cart.discount_codes)
      ? cart.discount_codes.some(dc => matchesJuly4Discount(typeof dc === 'string' ? dc : dc?.code))
      : false;

    const appHits = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications.some(app => matchesJuly4Discount(app?.title || app?.code))
      : false;

    return codeHits || appHits;
  }

  // —————————————————————
  // Refresh cart & render
  // —————————————————————
  async function refreshCart({ open = false } = {}) {
    try {
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();

      if (cart.item_count === 0) {
        drawerContent.innerHTML = `
          <div class="empty-drawer">
            <p style="padding:1.5rem;">Your cart is empty.</p>
            <a href="/" class="button button--primary">Continue Shopping</a>
          </div>`;
        footer.classList.add('hide-me');
        updateCartCount(cart);
      } else {
        // fetch compare_at prices + inventory
        const handles     = [...new Set(cart.items.map(i => i.handle))];
        const proms       = handles.map(h => fetch(`/products/${h}.js`).then(r => r.json()));
        const products    = await Promise.all(proms);
        const compareMap  = {};
        const inventoryMap= {};
        const tagsMap     = {}; // ← NEW
       
        products.forEach((prod) => {
          // prod.tags can be array or string; normalize to comma string
          const tagsStr = Array.isArray(prod.tags) ? prod.tags.join(',') : (prod.tags || '');

          prod.variants.forEach((v) => {
            compareMap[v.id]   = Math.round(parseFloat(v.compare_at_price || v.price));
            inventoryMap[v.id] = v.inventory_quantity;
            tagsMap[v.id]      = tagsStr; // map variant → product tags for Final Sale check
          });
        });

        // render items
        const hurry25Active = isHURRY25Active(cart);
        const fourthOfJulyActive = isFourthOfJulyActive(cart);
        drawerContent.innerHTML = cart.items
        .map(item => buildItemHTML(item, compareMap, inventoryMap, tagsMap, hurry25Active, fourthOfJulyActive))
        .join('');
        footer.classList.remove('hide-me');

        // update totals & progress
        updateCartSubtotal(cart);
        updateFreeShippingProgress(cart);
        updateCartCount(cart);

        // init custom dropdowns now that HTML is in DOM
        initCustomQtyDropdowns();
      }

      if (open) openDrawer();
    } catch (err) {
      console.error('Error refreshing cart:', err);
    }
  }

  // —————————————————————
  // Update footer subtotal
  // —————————————————————
  function updateCartSubtotal(cart) {
  const subEl = document.getElementById('CartDrawerSubtotal');
  if (subEl) subEl.textContent = formatMoney(cart.total_price);

  const installmentEl = document.getElementById('InstallmentPrice');
  const installments = 4;
  if (installmentEl) {
    const installmentCents = Math.round(cart.total_price / installments);
    installmentEl.textContent = formatMoney(installmentCents);
  }
}

  // —————————————————————
  // Custom dropdown initialization
  // —————————————————————
  function initCustomQtyDropdowns() {
    // close any open dropdown
    function closeAll() {
      drawerContent.querySelectorAll('.custom-qty-options.open')
        .forEach(ul => ul.classList.remove('open'));
      drawerContent.querySelectorAll('.custom-qty-toggle[aria-expanded="true"]')
        .forEach(btn => btn.setAttribute('aria-expanded','false'));
    }

    // toggle dropdown open/close
    drawerContent.querySelectorAll('.custom-qty-dropdown').forEach(dd => {
      const toggle = dd.querySelector('.custom-qty-toggle');
      const list   = dd.querySelector('.custom-qty-options');

      toggle.addEventListener('click', e => {
        e.stopPropagation();
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!isOpen) {
          toggle.setAttribute('aria-expanded','true');
          list.classList.add('open');
        }
      });

      // option click -> update cart
      dd.querySelectorAll('.custom-qty-option').forEach(opt => {
        opt.addEventListener('click', async e => {
          const newQty = parseInt(opt.dataset.value, 10);
          const key    = dd.dataset.lineItemKey;

          // update UI immediately
          dd.querySelector('.custom-qty-label').textContent = newQty;
          closeAll();

          // notify Shopify
          await fetch('/cart/change.js', {
            method: 'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          });

          // re-render entire cart
          await refreshCart();
        });
      });
    });

    // close dropdowns on click outside
    document.addEventListener('click', () => {
      drawerContent.querySelectorAll('.custom-qty-options.open')
        .forEach(ul => ul.classList.remove('open'));
      drawerContent.querySelectorAll('.custom-qty-toggle[aria-expanded="true"]')
        .forEach(btn => btn.setAttribute('aria-expanded','false'));
    });
  }

  // —————————————————————
  // Handle trash-can remove
  // —————————————————————
  document.body.addEventListener('click', async e => {
    const btn = e.target.closest('.cart-item-remove');
    if (!btn) return;
    const key = btn.dataset.removeKey;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await refreshCart();
  });

  // —————————————————————
  // AJAX add-to-cart override
  // —————————————————————
  document.body.addEventListener('submit', async e => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    await fetch('/cart/add.js', {
      method:'POST',
      body: new FormData(form),
      headers:{ 'Accept':'application/json' }
    });
    await refreshCart({ open:true });
  });

  // —————————————————————
  // Drawer open/close controls
  // —————————————————————
  if (openBtn) openBtn.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && body.classList.contains('cart-drawer-open')) {
      closeDrawer();
    }
  });

  // initialize on load
  refreshCart();

  // ───────────────────────── Recommendations Carousel ─────────────────────────
  const left_arrow = 
    `<button class="slick-prev slick-arrow" aria-label="Previous" type="button">
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487 487">
         <path d="M397.7,376.1c20.4,20.4,53.6,20.4,74,0s20.4-53.6,0-74L280.5,110.9c-20.4-20.4-53.6-20.4-74,0L15.3,302.1c-20.4,20.4-20.4,53.6,0,74s53.6,20.4,74,0l154.2-154.2L397.7,376.1z"/>
       </svg>
     </button>`;

  const right_arrow = 
    `<button class="slick-next slick-arrow" aria-label="Next" type="button">
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487 487">
         <path d="M397.7,376.1c20.4,20.4,53.6,20.4,74,0s20.4-53.6,0-74L280.5,110.9c-20.4-20.4-53.6-20.4-74,0L15.3,302.1c-20.4,20.4-20.4,53.6,0,74s53.6,20.4,74,0l154.2-154.2L397.7,376.1z"/>
       </svg>
     </button>`;

  function initRecommendationCarousel() {
    const $slider = $('.recommendation-carousel');
    if ($slider.length && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        nextArrow: right_arrow,
        prevArrow: left_arrow
      });
    }
  }

  initRecommendationCarousel();
  if (openBtn) openBtn.addEventListener('click', () => {
    setTimeout(initRecommendationCarousel, 50);
  });
});
